<notfound-page>
  <div>
    <h3>Fel</h3>
    Sidan du försökte nå kunde inte hittas.
  </div>

  <script>
    import './style.scss'
  </script>
</notfound-page>